import Axios from 'axios';
import formatISO from 'date-fns/formatISO';
import qs from 'qs';

export class MtsAudioModule {
  constructor(baseUrl = '/api/v1') {
    this.baseURL = baseUrl;
    this.http = Axios.create({
      baseURL: this.baseURL,
      withCredentials: true,
      paramsSerializer: (params) => (
        qs.stringify(params, {
          arrayFormat: 'comma',
          serializeDate: formatISO,
        })),
    });
  }

  async healthcheck() {
    try {
      return await this.http.post('/antispoofing/check');
    } catch (e) {
      if (e?.code === 'ECONNABORTED') throw e;
      if (e?.response?.status >= 500) throw e;
    }
    return undefined;
  }

  get antispoofing() {
    const prefix = 'antispoofing';
    return {
      check: async (payload) => {
        const { data } = await this.http.post(`/${prefix}/check`, payload);
        return data;
      },
    };
  }
}

export const mtsAudioModule = new MtsAudioModule();
